import {
  AtividadeColetivaGrupoSelectQuery,
  GrupoParticipanteAtividadeColetiva,
  Lotacao,
} from '../../../../graphql/types.generated'
import { emptyArrayOf, partition } from '../../../../util/array'
import { convertEquipesEnvolvidas } from '../../grupos/converter-atividadeColetivaGrupos'
import {
  AtividadeColetivaGrupoCabecalho,
  AtividadeColetivaGrupoItemModel,
  AtividadeColetivaGrupoSelectItemModel,
  AtividadeColetivaGrupoSemResultados,
} from './model-atividadeColetivaGrupoSelectField'

export const convertToAtividadeColetivaGrupoSelectFieldModel = (
  queryData: AtividadeColetivaGrupoSelectQuery,
  profissionalLogadoId: ID
): AtividadeColetivaGrupoSelectItemModel[] => {
  const items: AtividadeColetivaGrupoSelectItemModel[] = []
  const data =
    queryData?.gruposParticipantesAtividadeColetiva?.content || emptyArrayOf<GrupoParticipanteAtividadeColetiva>()

  const groupPartitionPredicate = (grupo: GrupoParticipanteAtividadeColetiva) => {
    return grupo?.lotacoesEnvolvidas?.some((lotacao: Lotacao) => lotacao?.profissional?.id === profissionalLogadoId)
  }

  const [meusGrupos, outrosGrupos] = partition(data, groupPartitionPredicate).map((group) => {
    return group.isEmpty()
      ? [AtividadeColetivaGrupoSemResultados.SEM_RESULTADOS_ENCONTRADOS]
      : group.map(convertItemModelToSelectModel)
  })

  items.push(AtividadeColetivaGrupoCabecalho.MEUS_GRUPOS)
  items.push(...meusGrupos)
  items.push(AtividadeColetivaGrupoCabecalho.OUTROS_GRUPOS)
  items.push(...outrosGrupos)

  return items
}

const convertItemModelToSelectModel = (grupo: GrupoParticipanteAtividadeColetiva): AtividadeColetivaGrupoItemModel => {
  const nome = grupo.nome
  const equipesEnvolvidas = convertEquipesEnvolvidas(grupo.lotacoesEnvolvidas)
  const unidadeDeSaude = grupo.unidadeSaude?.nome
  const cidadaos = grupo.cidadaosParticipantes ?? []
  const lotacoes = grupo.lotacoesEnvolvidas ?? []

  return {
    nome,
    equipesEnvolvidas,
    unidadeDeSaude,
    cidadaos,
    lotacoes,
  }
}
